import PropTypes from "prop-types"
import SecondaryTitle from "../Section/SecondaryTitle"
import { BUTTON_TEXT, ERROR } from "../consts"
import "./whitelist.css"
import { CirclePlus } from "../svgs/SVGS"
import FormService from "../../services/formService"
import { IP_REGEX } from "./const"
import { useState, useEffect, memo, useCallback } from "react"
import WhitelistBody from "./Partials/whitelistBody"
import Section from "../Section"

const secondaryTitle = (
  <SecondaryTitle showCheckState={false} text="Adding IPs" />
)

const ButtonText = memo(({ loading, text, disabled }) => (
  <>
    {!loading && (
      <CirclePlus color={window.cheqEssential ? "#e12468" : "#fc6723"} />
    )}
    <div>{text}</div>
  </>
))

let updateTimeout = null
function Whitelist({ list, maxLength }) {
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const [actionText, setActionText] = useState(BUTTON_TEXT.SAVE)
  const [ips, setIps] = useState([""])
  const formService = new FormService()

  const toggleSuccess = () => {
    setActionText(BUTTON_TEXT.SUCCESS)
    setTimeout(() => {
      setActionText(BUTTON_TEXT.SAVE)
    }, 1000)
  }

  const toggleError = () => {
    setError(ERROR.WHITELIST_UPDATE)
    setActionText(BUTTON_TEXT.ERROR)
    setTimeout(() => {
      setActionText(BUTTON_TEXT.SAVE)
    }, 1000)
  }

  const setUpdateWhitelist = async (ips) => {
    updateTimeout = setTimeout(async () => await updateWhitelist(ips), 1500)
  }

  const updateWhitelist = async (ips) => {
    clearTimeout(updateTimeout)
    setLoading(true)
    const error = await formService.updateWhitelist(ips)
    if (error) toggleError()
    else toggleSuccess()
    setLoading(false)
  }

  const removeIP = async (index) => {
    const tempList = [...ips]
    tempList.splice(index, 1)
    setIps(tempList)
    await updateWhitelist(tempList)
  }

  const updateIP = async (index, value) => {
    clearTimeout(updateTimeout)
    const newList = [...ips]
    newList[index] = value
    setIps([...newList])
    if (!value) {
      setError(null)
      await setUpdateWhitelist(newList)
    } else if (IP_REGEX.test(value)) {
      if (ips.some((ip) => ip === value)) setError(ERROR.DUPLICATE_IP)
      else {
        setError(null)
        await setUpdateWhitelist(newList)
      }
    } else setError(ERROR.INVALID_IP)
  }

  const paste = async (index) => {
    const text = await navigator.clipboard.readText()
    updateIP(index, text)
  }

  const addNewItem = () => {
    if (ips.length <= maxLength - 1) setIps([...ips, ""])
  }

  const validIP = useCallback(
    () => ips.length && IP_REGEX.test(ips[ips.length - 1]),
    [ips]
  )

  const onIpsChange = () => {
    if (!list || !list.length) setIps([""])
    else if (
      ips.length !== list.length ||
      ips.some((_, i) => ips[i] !== list[i])
    )
      setIps([...list])

    if (loading) setLoading(false)
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(onIpsChange, [list])

  return (
    <Section
      title="Whitelist IPs (optional)"
      body={
        <WhitelistBody
          ips={ips}
          loading={loading}
          disabled={ips.length === maxLength || !validIP()}
          error={error}
          sideSlotCB={removeIP}
          inputInnerCB={paste}
          buttonText={
            actionText === BUTTON_TEXT.SUCCESS ? (
              BUTTON_TEXT.SUCCESS
            ) : (
              <ButtonText
                loading={loading}
                text={`Add IP Address ${ips.length}/${maxLength}`}
                disabled={ips.length === maxLength || !validIP()}
              />
            )
          }
          addNewItemCB={addNewItem}
          updateIPCB={updateIP}
        />
      }
      secondaryTitle={secondaryTitle}
    />
  )
}

Whitelist.propTypes = {
  ips: PropTypes.arrayOf(PropTypes.string),
  maxLength: PropTypes.number,
}

Whitelist.defaultProps = {
  ips: [""],
  maxLength: 1,
}

export default Whitelist
